var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showContent)?_c('Modal',{attrs:{"config":_vm.modalConfig.forceLogout},on:{"btn2Action":_vm.loginAgain}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }